var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-xs-center",staticStyle:{"height":"50px","max-width":"400px"},attrs:{"dark":""}},[_c('v-card-text',{staticClass:"align-center caption"},[_vm._v("地点カテゴリーは、地点を表示できません。")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }